import React from 'react';

import Nav from '../index';

const navProps = {
  currentUser: {
    isLoggedIn: true,
    isProSubscriber: false,
    isSubscriber: true,
    willSubscriptionChange: false,
    canViewGiftOption: false,
    profileCompletionPercentage: 100,
    profileCompletionStatuses: [
      {
        text: 'profile',
        isComplete: true,
        href: 'https://google.com',
      },
    ],
    shouldShowScrolledNav: false,
    // props needed to satisfy User type. Not important for the test, so values are mostly arbitrary
    access_level: 3,
    administrator: {
      is_active: false,
    },
    authenticated_by_jwt: true,
    can_actually_comment: true,
    can_initiate_mobile_subscription: true,
    can_update_payment: true,
    company_name: null,
    comped: false,
    email: 'test@email.com',
    guid: 'aabbccdd',
    has_set_password: true,
    id: 25,
    identity_id: 25,
    is_corp_or_group_subscriber: false,
    is_free_edition_user: false,
    is_new_user: false,
    is_pro_subscriber: false,
    is_subscriber: true,
    login_link_only: false,
    name: 'user',
    one_line_bio: null,
    permitted_to_comment: true,
    picture_url: null,
    profile_enabled: true,
    referral_url: '',
    requires_name_to_comment: false,
    settings_access_obj: {
      gift_sub_access: false,
      privacy_access: true,
      referral_access: false,
      team_sub_access: false,
    },
    staff: false,
    subscription: {
      is_active: true,
      is_past_due: false,
      is_pro: false,
      plan_type: 'pro',
      source: 'stripe',
    },
    stripe_customer_id: 'aabbccdd',
    subscription_status: 'active',
    title_at_company: null,
    username: 'some_username',
  },
};

describe('<Nav />', () => {
  it('renders', () => {
    const { queryAllByText, queryByLabelText } = global.render(<Nav {...navProps} />);
    expect(queryAllByText('Tech')[0]).toBeInTheDocument();
    // 'border-black' is only available on non-DarkStyle variant of the nav
    expect(queryByLabelText('global')).toHaveClass('border-black');
  });

  it('renders the article paywall version', () => {
    const navPropsWithScrollStyle = {
      ...navProps,
      currentUser: { ...navProps.currentUser, shouldShowScrolledNav: true },
    };
    const { queryAllByText, queryByLabelText } = global.render(
      <Nav {...navPropsWithScrollStyle} />
    );
    expect(queryAllByText('Tech')[0]).toBeInTheDocument();
    // 'mt-0' is only available on the DarkStyle variant of the nav
    expect(queryByLabelText('global')).toHaveClass('mt-0');
  });
});
